import { memo, ReactNode, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Scrollbars, ScrollbarType } from "@tecorien/mimic";
import { Navbar } from "./Navbar";

import styles from "./style.module.scss";

export type AuthLayoutProps = {
  children?: ReactNode | ReactNode[],
  hideMenu?: boolean
  hideProfile?: boolean
  rootLink?: string
}

export const SiteLayout = memo<AuthLayoutProps>(({ children, hideMenu, hideProfile, rootLink }) => {
  const scrollRef = useRef<ScrollbarType>();
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.style.setProperty("--background-color", "white");
  }, []);

  useEffect(() => {
    scrollRef?.current?.osInstance()
      ?.scroll
      ?.({ top: 0, left: 0 });
  }, [ scrollRef, pathname ]);

  return (
    <div className={styles.root}>
      <Navbar
        className={styles.navbar}
        hideMenu={hideMenu}
        hideProfile={hideProfile}
        rootLink={rootLink}
      />
      <Scrollbars
        className={styles.scrollbar}
        ref={scrollRef}
        options={{ sizeAutoCapable: false }}
      >
        {children}
      </Scrollbars>
    </div>
  );
});

export default SiteLayout;